// extracted by mini-css-extract-plugin
module.exports = {"collection":"n8I0h0","imageContainer":"_3pBvNn","title":"QwG3Bf","image":"zxqrSi"};